import React from 'react'
import { Head, Link, Redirect } from 'react-static'
import styled from 'styled-components'
import Script from 'react-load-script'
import validate from 'validate.js'

import ContactModal from './ContactModal'
import Button from '../../common/Button'

import arrowLeft from '../../../images/icons/arrow-left-red.png'
import steps from '../../../images/zebra.jpg'

const Wrapper = styled.section`
  min-height: 100vh;
  z-index: 1;
  position: relative;
  padding: 2em 1em;
  background-color: ${props => props.theme.secondary.bg2};
  background: url(${steps}) repeat;
  display: flex;
  justify-content: center;
  align-items: center;

  .inner {
    width: 500px;
    max-width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  h2 {
    color: #fff;
    display: block;
    margin: 0 auto 0.8em;
    font-size: 1.8em;
    padding-top: 1.5em;
    height: 5em;
    width: 5em;
    background-color: ${props => props.theme.main.bg};
    border-radius: 100%;
    text-shadow: 3px 3px 0 ${props => props.theme.main.hover};
  }

  .email {
    display: block;
    margin: 2.5em 0 1em;
    font-size: 1.5em;

    &:hover {
      text-decoration: underline;
    }
  }

  .contact-home-link {
    margin-top: 2em;
    display: inline-block;

    button {
      border: none;
      font-size: 0.9em;
      padding-left: 0;
      padding-right: 0;

      img {
        width: 2em;
        margin-right: 1em;
        vertical-align: middle;
        margin-top: -0.2em;
      }
    }
  }
`

const Form = styled.div`
  text-align: left;
  margin: 0 auto;

  & > div:not(:last-child) {
    margin-bottom: 1em;
  }

  label {
    display: block;
    margin-bottom: 0.3em;
  }

  input,
  textarea {
    width: 100%;
    border: none;
    padding: 0.5em;
    border-radius: 2px;
  }

  input {
    height: 1.8em;
  }

  button {
    width: 100%;
    font-size: 1em;
    transition: all 0.3s ease;
    background-color: ${props => props.theme.main.bg};
    border-color: ${props => props.theme.main.bg};
    color: #fff;

    &:hover {
      color: ${props => props.theme.main.bg};
      background-color: ${props => props.theme.main.hover};
      border-color: ${props => props.theme.main.hover};
    }
  }

  .validation-error {
    background-color: ${props => props.theme.secondary.bg3};
  }

  .validation-error-message {
    color: ${props => props.theme.secondary.bg3};
  }
`

export default class Contact extends React.Component {
  state = {
    name: '',
    email: '',
    message: '',
    nameValid: true,
    emailValid: true,
    messageValid: true,
    nameError: null,
    emailError: null,
    messageError: null,
    modal: false,
    modalMessage: '',
    redirect: false,
  }
  constraints = {
    name: {
      presence: true,
      format: {
        pattern: '[a-zA-Z ]+',
        flags: 'i',
        message: 'can only contain letters',
      },
    },
    email: {
      presence: true,
      email: true,
    },
    message: {
      presence: true,
      length: {
        maximum: 500,
      },
    },
  }
  handleScriptError = this.handleScriptError.bind(this)
  handleScriptLoad = this.handleScriptLoad.bind(this)
  handleFormChange = this.handleFormChange.bind(this)
  validateSingle = this.validateSingle.bind(this)
  handleSendClick = this.handleSendClick.bind(this)
  validateAll = this.validateAll.bind(this)
  showError = this.showError.bind(this)
  sendEmail = this.sendEmail.bind(this)
  displayModal = this.displayModal.bind(this)

  handleScriptError(script) {
    console.log(`${script} error`)
  }

  handleScriptLoad(script) {
    if (script === 'emailjs') {
      emailjs.init('user_2mNPJ81EyVF4nNZBvqStM') // eslint-disable-line
    }
  }

  handleFormChange(e) {
    let key = e.target.name
    let value = e.target.value
    this.setState({ [key]: value }, () => {
      this.validateSingle(key, value)
    })
  }

  validateSingle(key, value) {
    const validKey = `${key}Valid`
    const errorKey = `${key}Error`

    if (value === '') {
      this.setState({
        [validKey]: false,
        [errorKey]: `${key.charAt(0).toUpperCase() + key.slice(1)} can't be blank`,
      })
    } else {
      this.setState({
        [validKey]: true,
        [errorKey]: null,
      })
    }
  }

  handleSendClick() {
    const { name, email, message } = this.state
    this.validateAll(name, email, message)
  }

  validateAll(name, email, message) {
    const error = validate({ name: name, email: email, message: message }, this.constraints)

    if (!error) {
      return this.sendEmail(name, email, message)
    }

    if (error.name) {
      this.showError('name', error.name)
    }
    if (error.email) {
      this.showError('email', error.email)
    }
    if (error.message) {
      this.showError('message', error.message)
    }
  }

  showError(key, error) {
    const validKey = `${key}Valid`
    const errorKey = `${key}Error`

    this.setState({
      [validKey]: false,
      [errorKey]: error[0],
    })
  }

  sendEmail(name, email, message) {
    emailjs
      .send('bagnall', 'bagnall_hill', {
        // eslint-disable-line
        name: name,
        email: email,
        message: message,
      })
      .then(
        res => {
          this.displayModal('Message sent', true)
        },
        err => {
          // if (err.text === '{"error":"CAPTCHA data missing"}') {
          // 	this.displayModal("Please confirm you are a human", false)
          // } else {
          this.displayModal('Something went wrong, please try again.', false)
          // }
        }
      )
  }

  displayModal(message, redirect) {
    this.setState(
      {
        modal: true,
        modalMessage: message,
      },
      () => {
        setTimeout(() => {
          if (redirect) {
            this.setState({ redirect: true })
          } else {
            this.setState({
              modal: false,
              modalMessage: '',
            })
          }
        }, 1000)
      }
    )
  }

  render() {
    const {
      name,
      email,
      message,
      nameValid,
      nameError,
      emailValid,
      emailError,
      messageValid,
      messageError,
      redirect,
      modal,
      modalMessage,
    } = this.state
    return (
      <Wrapper>
        <Head>
          <title>Contact</title>
          <meta
            name="description"
            content="For bookings or enquiries please email us using the form below and we'll be in touch soon."
          />
        </Head>
        {/* <Script
					url="https://www.google.com/recaptcha/api.js"
					onError={() => this.handleScriptError('recaptcha')}
					onLoad={() => this.handleScriptLoad('recaptcha')}
			    /> */}
        <Script
          url="https://cdn.emailjs.com/dist/email.min.js"
          onError={() => this.handleScriptError('emailjs')}
          onLoad={() => this.handleScriptLoad('emailjs')}
        />
        <div className="inner">
          <h2>CONTACT US</h2>
          <div>
            <a className="email" href="mailto:contact@bagnallhill.co.nz">
              contact@bagnallhill.co.nz
            </a>
          </div>
          {/* <Form>
						<div>
							<label htmlFor="name">Name:</label>
							<input type="text"
								name="name"
								id="name"
								value={name}
								className={!nameValid ? 'validation-error' : ''}
								onChange={this.handleFormChange}/>
							<p className="validation-error-message">{nameError}</p>
						</div>
						<div>
							<label htmlFor="email">Email:</label>
							<input type="email"
								name="email"
								id="email"
								value={email}
								className={!emailValid ? 'validation-error' : ''}
								onChange={this.handleFormChange}/>
							<p className="validation-error-message">{emailError}</p>
						</div>
						<div>
							<label htmlFor="message">Message:</label>
							<textarea name="message"
								id="message"
								cols="30"
								rows="10"
								value={message}
								className={!messageValid ? 'validation-error' : ''}
								onChange={this.handleFormChange}></textarea>
							<p className="validation-error-message">{messageError}</p>
						</div>
						<div className="g-recaptcha" data-sitekey="6LcpYTMUAAAAAOBdu64nS-8HNnE2VxGDGaMWn2mZ"></div>
						<div>
							<Button click={this.handleSendClick}>Send</Button>
						</div>
          </Form>
          */}
          <Link className="contact-home-link" to="/">
            <Button>
              <img src={arrowLeft} alt="back" />
              <span>Back to homepage</span>
            </Button>
          </Link>
        </div>
        {modal && <ContactModal message={modalMessage} />}
        {redirect && <Redirect to="/" />}
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/contact/Contact.js